import React, { useState } from 'react'
import { motion } from 'framer-motion'

const countries = [
  "Afghanistan", "Albania", "Algeria", "American Samoa", "Andorra", "Angola", "Anguilla", "Antarctica",
  "Antigua and Barbuda", "Argentina", "Armenia", "Aruba", "Australia", "Austria", "Azerbaijan", "Bahamas",
  "Bahrain", "Bangladesh", "Barbados", "Belarus", "Belgium", "Belize", "Benin", "Bermuda", "Bhutan",
  "Bolivia", "Bosnia and Herzegovina", "Botswana", "Bouvet Island", "Brazil", "British Indian Ocean Territory",
  "Brunei Darussalam", "Bulgaria", "Burkina Faso", "Burundi", "Cambodia", "Cameroon", "Canada", "Cape Verde",
  "Cayman Islands", "Central African Republic", "Chad", "Chile", "China", "Christmas Island", "Cocos (Keeling) Islands",
  "Colombia", "Comoros", "Congo", "Congo, The Democratic Republic of the", "Cook Islands", "Costa Rica",
  "Cote D'Ivoire", "Croatia", "Cuba", "Cyprus", "Czech Republic", "Denmark", "Djibouti", "Dominica",
  "Dominican Republic", "Ecuador", "Egypt", "El Salvador", "Equatorial Guinea", "Eritrea", "Estonia",
  "Ethiopia", "Falkland Islands (Malvinas)", "Faroe Islands", "Fiji", "Finland", "France", "French Guiana",
  "French Polynesia", "French Southern Territories", "Gabon", "Gambia", "Georgia", "Germany", "Ghana",
  "Gibraltar", "Greece", "Greenland", "Grenada", "Guadeloupe", "Guam", "Guatemala", "Guernsey", "Guinea",
  "Guinea-Bissau", "Guyana", "Haiti", "Heard Island and Mcdonald Islands", "Holy See (Vatican City State)",
  "Honduras", "Hong Kong", "Hungary", "Iceland", "India", "Indonesia", "Iran, Islamic Republic Of", "Iraq",
  "Ireland", "Isle of Man", "Italy", "Jamaica", "Japan", "Jersey", "Jordan", "Kazakhstan", "Kenya",
  "Kiribati", "Korea, Democratic People'S Republic of", "Korea, Republic of", "Kuwait", "Kyrgyzstan",
  "Lao People'S Democratic Republic", "Latvia", "Lebanon", "Lesotho", "Liberia", "Libyan Arab Jamahiriya",
  "Liechtenstein", "Lithuania", "Luxembourg", "Macao", "Macedonia, The Former Yugoslav Republic of",
  "Madagascar", "Malawi", "Malaysia", "Maldives", "Mali", "Malta", "Marshall Islands", "Martinique",
  "Mauritania", "Mauritius", "Mayotte", "Mexico", "Micronesia, Federated States of", "Moldova, Republic of",
  "Monaco", "Mongolia", "Montserrat", "Morocco", "Mozambique", "Myanmar", "Namibia", "Nauru", "Nepal",
  "Netherlands", "Netherlands Antilles", "New Caledonia", "New Zealand", "Nicaragua", "Niger", "Nigeria",
  "Niue", "Norfolk Island", "Northern Mariana Islands", "Norway", "Oman", "Pakistan", "Palau",
  "Palestinian Territory, Occupied", "Panama", "Papua New Guinea", "Paraguay", "Peru", "Philippines",
  "Pitcairn", "Poland", "Portugal", "Puerto Rico", "Qatar", "Reunion", "Romania", "Russian Federation",
  "RWANDA", "Saint Helena", "Saint Kitts and Nevis", "Saint Lucia", "Saint Pierre and Miquelon",
  "Saint Vincent and The Grenadines", "Samoa", "San Marino", "Sao Tome and Principe", "Saudi Arabia",
  "Senegal", "Serbia and Montenegro", "Seychelles", "Sierra Leone", "Singapore", "Slovakia", "Slovenia",
  "Solomon Islands", "Somalia", "South Africa", "South Georgia and The South Sandwich Islands", "Spain",
  "Sri Lanka", "Sudan", "Suriname", "Svalbard and Jan Mayen", "Swaziland", "Sweden", "Switzerland",
  "Syrian Arab Republic", "Taiwan, Province of China", "Tajikistan", "Tanzania, United Republic of",
  "Thailand", "Timor-Leste", "Togo", "Tokelau", "Tonga", "Trinidad and Tobago", "Tunisia", "Turkey",
  "Turkmenistan", "Turks and Caicos Islands", "Tuvalu", "Uganda", "Ukraine", "United Arab Emirates",
  "United Kingdom", "United States", "United States Minor Outlying Islands", "Uruguay", "Uzbekistan",
  "Vanuatu", "Venezuela", "Viet Nam", "Virgin Islands, British", "Virgin Islands, U.S.", "Wallis and Futuna",
  "Western Sahara", "Yemen", "Zambia", "Zimbabwe", "Not In List"
]

const inputCls =
  'w-full rounded-xl border border-slate-300 bg-white px-4 py-3 text-slate-900 placeholder:text-slate-400 transition focus:outline-none focus:border-[#F97316] focus:ring-4 focus:ring-orange-500/20'
const labelCls = 'block text-sm font-semibold text-slate-700 mb-1.5'

const ContactPage = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    country: '',
    service: '',
    message: ''
  })

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    })
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    // Handle form submission here
    console.log('Form submitted:', formData)
  }

  return (
    <div className="pt-20 min-h-screen bg-white text-slate-900 antialiased">
      {/* Hero Section */}
      <section className="relative overflow-hidden bg-slate-900 text-white">
        <div
          aria-hidden="true"
          className="absolute inset-0 opacity-30"
          style={{ backgroundImage: 'radial-gradient(60rem 28rem at 85% -10%, rgba(249,115,22,.35), transparent 60%)' }}
        />
        <svg
          aria-hidden="true"
          className="absolute bottom-10 left-0 w-full h-24 text-[#F97316]/40"
          viewBox="0 0 1200 96"
          preserveAspectRatio="none"
          fill="none"
        >
          <path
            d="M0 60 C 200 10, 400 110, 600 55 S 1000 10, 1200 60"
            stroke="currentColor"
            strokeWidth="2.5"
            strokeDasharray="10 9"
            strokeLinecap="round"
          />
        </svg>
        <div className="relative max-w-6xl mx-auto px-6 py-28 md:py-36">
          <motion.h1
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7 }}
            className="text-5xl md:text-7xl font-extrabold tracking-tight leading-[1.05]"
          >
            Contact <span className="text-[#F97316]">Us</span>
          </motion.h1>
          <motion.p
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.15 }}
            className="mt-6 text-lg md:text-xl text-slate-300 max-w-xl leading-relaxed"
          >
            Let's discuss your project and bring your vision to life
          </motion.p>
        </div>
      </section>

      {/* Contact Information */}
      <section className="relative overflow-hidden py-20 md:py-28">
        <div aria-hidden="true" className="pointer-events-none absolute -top-32 -left-32 h-96 w-96 rounded-full bg-orange-200/40 blur-3xl" />
        <div aria-hidden="true" className="pointer-events-none absolute -bottom-40 -right-32 h-96 w-96 rounded-full bg-amber-200/40 blur-3xl" />

        <div className="relative max-w-6xl mx-auto px-6 grid grid-cols-1 lg:grid-cols-5 gap-10 lg:gap-14">
          {/* Contact Details */}
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="lg:col-span-2 space-y-8"
          >
            <h2 className="text-4xl md:text-5xl font-extrabold tracking-tight leading-[1.05]">
              Let's Talk{' '}
              <span className="bg-gradient-to-r from-orange-500 via-red-500 to-amber-500 bg-clip-text text-transparent">
                Business
              </span>
            </h2>

            <div>
              <h3 className="text-xl font-bold mb-2">Talk to a Specialist</h3>
              <p className="text-slate-600 leading-relaxed">
                Drop us a line about your project and we will contact you within a business day.
                All submitted information will be kept confidential.
              </p>
            </div>

            <div className="rounded-3xl border border-dashed border-slate-300 bg-white/80 p-6">
              <h3 className="text-xl font-bold mb-5">Contact Details</h3>
              <dl className="space-y-4">
                <p className="text-lg font-bold text-[#F97316] leading-snug">
                  VECTOR VISIONARY
                </p>
                
                <div className="flex gap-3">
                  <dt className="w-16 shrink-0 font-semibold text-[#F97316]">Email</dt>
                  <dd className="text-slate-700 break-all">
                    max@vectorvisionary.com
                    <br />
                    team@vectorvisionary.com
                  </dd>
                </div>
                <div className="flex gap-3">
                  <dt className="w-16 shrink-0 font-semibold text-[#F97316]">Phone</dt>
                  <dd className="text-slate-700">
            
                    (209) 964-6220
                  </dd>
                </div>
                <div className="flex gap-3">
                  <dt className="w-16 shrink-0 font-semibold text-[#F97316]">Address</dt>
                  <dd className="text-slate-700 leading-relaxed">
                    841 Van Ness Ave, Fresno, CA, United States, 93721
                  </dd>
                </div>
              </dl>
            </div>

            <div className="relative overflow-hidden rounded-3xl bg-slate-900 p-8 text-white">
              <div aria-hidden="true" className="pointer-events-none absolute -top-10 -right-10 h-40 w-40 rounded-full bg-orange-500/30 blur-3xl" />
              <h3 className="relative text-xl font-bold mb-4">Business Hours (UTC/GMT-7)</h3>
              <div className="relative space-y-2 text-slate-300">
                <p><strong className="text-white">Monday-Friday:</strong> 9am - 5pm</p>
                <p><strong className="text-white">Saturday-Sunday:</strong> (Closed)</p>
              </div>
            </div>
          </motion.div>

          {/* Contact Form */}
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.1 }}
            className="lg:col-span-3 relative self-start overflow-hidden rounded-3xl border border-slate-200 bg-white p-8 pt-10 md:p-10 md:pt-12 shadow-xl shadow-orange-100/60"
          >
            <div className="absolute left-0 top-0 h-1.5 w-full bg-gradient-to-r from-orange-500 via-red-500 to-amber-500" />
            <h3 className="text-3xl font-extrabold tracking-tight mb-8">Request a Call</h3>

            <form onSubmit={handleSubmit} className="space-y-5">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                <div>
                  <label htmlFor="name" className={labelCls}>Full Name *</label>
                  <input type="text" id="name" name="name" value={formData.name} onChange={handleChange} required className={inputCls} />
                </div>
                <div>
                  <label htmlFor="email" className={labelCls}>Email Address *</label>
                  <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} required className={inputCls} />
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                <div>
                  <label htmlFor="phone" className={labelCls}>Phone Number</label>
                  <input type="tel" id="phone" name="phone" value={formData.phone} onChange={handleChange} className={inputCls} />
                </div>
                <div>
                  <label htmlFor="country" className={labelCls}>Country *</label>
                  <select id="country" name="country" value={formData.country} onChange={handleChange} required className={inputCls}>
                    <option value="">--Please Select Your Country--</option>
                    {countries.map((country) => (
                      <option key={country} value={country}>{country}</option>
                    ))}
                  </select>
                </div>
              </div>

              <div>
                <label htmlFor="service" className={labelCls}>About Service *</label>
                <select id="service" name="service" value={formData.service} onChange={handleChange} required className={inputCls}>
                  <option value="">--About Service--</option>
                  <option value="digitizing">Digitizing</option>
                  <option value="vectorization">Vectorization</option>
                  <option value="patches">Patches</option>
                  <option value="request-quote">Request A Quote</option>
                  <option value="other">Other</option>
                </select>
              </div>

              <div>
                <label htmlFor="message" className={labelCls}>Project Details *</label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  rows={5}
                  className={inputCls}
                  placeholder="Tell us about your project, requirements, and any specific details..."
                />
              </div>

              <button
                type="submit"
                className="w-full rounded-xl bg-slate-900 px-8 py-4 text-lg font-semibold text-white transition-colors hover:bg-[#F97316] focus:outline-none focus-visible:ring-4 focus-visible:ring-orange-500/40"
              >
                Send Message
              </button>
            </form>
          </motion.div>
        </div>
      </section>
    </div>
  )
}

export default ContactPage